import { IppicaScommesseTableTitles } from 'features/ippica/components/ippicaScommesseTableTitles';
import React from 'react';
import { VirtualScommesseCorsaProps } from '.';
import { VirtualScommesseCorsaRow } from '../virtualScommesseCorsaRow';
import { VirtualScommesseQuotePlurime } from '../virtualScommesseQuotePlurime';
import styles from './VirtualScommesseCorsa.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export const VirtualScommesseCorsa = ({
  title,
  headers,
  children,
  hasMarginBottom,
  hasBackground,
  className,
  classNameTitle,
  stato,
  list,
  quoteFinali,
  addBorderBottom,
}: VirtualScommesseCorsaProps) => {
  const { isMobile } = useWindowSize();

  return (
    <div
      className={`${styles.container} ${hasMarginBottom ? styles.containerMarginBottom : ''} ${
        hasBackground ? styles.containerHasBackground : ''
      } ${className ? className : ''}`}
    >
      <div className={`${styles.titlesContainer} ${title ? styles.withTitle : ''}`}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {!isMobile && headers && (
          <IppicaScommesseTableTitles
            containerClassName={`${styles.titlesBoxes} ${classNameTitle ? classNameTitle : ''}`}
            titles={headers}
          />
        )}
      </div>

      {list?.map((item, index: number, self) => {
        return (
          <VirtualScommesseCorsaRow
            key={`${item}-${index}`}
            {...item}
            stato={stato}
            hasBorderBottom={addBorderBottom ? index === self.length - 1 : false}
          />
        );
      })}
      {!!quoteFinali?.length && <VirtualScommesseQuotePlurime quoteFinali={quoteFinali} />}
      {children && children}
    </div>
  );
};
